import { EmailSet } from "./EmailSet";

export class EmailRequestMessage {
  InternalId: string;
  RegionId: string;
  FeatureId: string;
  Data: string;
  OrganizationId: string;
  IsImportant: boolean;
  IsPlainText: boolean;
  Subject: string;
  Body: string;
  ProviderTemplateId: string;
  SendTo: EmailSet[];
  SendCc: EmailSet[];
  SendBcc: EmailSet[];
  SendFrom: EmailSet;
  ReplyTo: string;
  ScheduledAt: Date;
  SendOutAt: Date;
  ProviderTags: string[];
}
